import { getEmployee_employee_office_address } from 'Constants/graphql/queries/employee/__generated__/getEmployee'
import { getEmployeeContact_employee_contact } from 'Constants/graphql/queries/employee/__generated__/getEmployeeContact'
import { getOrderEmployee_employee_office_address } from 'Constants/graphql/queries/feature/__generated__/getOrderEmployee'
import { getOrderOrganisation_organisation_offices_offices_address } from 'Constants/graphql/queries/feature/__generated__/getOrderOrganisation'
import { getOrganisation_organisation_contact_address } from 'Constants/graphql/queries/organisation/__generated__/getOrganisation'

export type OrderAddressFormProps = {
  chosenShippingAddress:
    | getOrderEmployee_employee_office_address
    | getOrderOrganisation_organisation_offices_offices_address
    | null
  chosenShippingAddressType: AddressTypeEnum | null
  employeeContact?: getEmployeeContact_employee_contact | null
  officeAddress:
    | getOrganisation_organisation_contact_address
    | getEmployee_employee_office_address
    | null
  onSetChosenShippingAddressLabel: (label: string) => void
  onSetChosenShippingAddressType: (address: AddressTypeEnum | null) => void
  onBackButtonClick: () => void
  onSubmitButtonClick: (
    address:
      | getOrderEmployee_employee_office_address
      | getOrderOrganisation_organisation_offices_offices_address
      | null,
  ) => void
}

export enum AddressTypeEnum {
  Office,
  Custom,
}
